// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"Checkbox_checkboxContainer__1lni0","checkmark":"Checkbox_checkmark__1C71g","text":"Checkbox_text__3thK2"};